import getQueryParam from 'lib/common/utils/getQueryParam';

const ISOLATED_MODE_QUERY_PARAM = 'standalone';

export default function isIsolatedMode() {
  return Boolean(getQueryParam({ param: ISOLATED_MODE_QUERY_PARAM }));
}
